/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StreakIndicator
 */
export interface StreakIndicator {
    /**
     * 
     * @type {number}
     * @memberof StreakIndicator
     */
    consecutiveOnTimeCompletions?: number;
    /**
     * 
     * @type {number}
     * @memberof StreakIndicator
     */
    lookbackDays?: number;
    /**
     * 
     * @type {number}
     * @memberof StreakIndicator
     */
    completionRateRollingWindow?: number;
    /**
     * 
     * @type {Date}
     * @memberof StreakIndicator
     */
    lastCompletedAt?: Date;
}

/**
 * Check if a given object implements the StreakIndicator interface.
 */
export function instanceOfStreakIndicator(value: object): value is StreakIndicator {
    return true;
}

export function StreakIndicatorFromJSON(json: any): StreakIndicator {
    return StreakIndicatorFromJSONTyped(json, false);
}

export function StreakIndicatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakIndicator {
    if (json == null) {
        return json;
    }
    return {
        
        'consecutiveOnTimeCompletions': json['consecutiveOnTimeCompletions'] == null ? undefined : json['consecutiveOnTimeCompletions'],
        'lookbackDays': json['lookbackDays'] == null ? undefined : json['lookbackDays'],
        'completionRateRollingWindow': json['completionRateRollingWindow'] == null ? undefined : json['completionRateRollingWindow'],
        'lastCompletedAt': json['lastCompletedAt'] == null ? undefined : (new Date(json['lastCompletedAt'])),
    };
}

export function StreakIndicatorToJSON(json: any): StreakIndicator {
    return StreakIndicatorToJSONTyped(json, false);
}

export function StreakIndicatorToJSONTyped(value?: StreakIndicator | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'consecutiveOnTimeCompletions': value['consecutiveOnTimeCompletions'],
        'lookbackDays': value['lookbackDays'],
        'completionRateRollingWindow': value['completionRateRollingWindow'],
        'lastCompletedAt': value['lastCompletedAt'] == null ? undefined : ((value['lastCompletedAt']).toISOString()),
    };
}

